// $( window ).resize(function() {
//   var annh = $('header').height();
//   $('.wrapper').css('margin-top',annh+'px');
// });

$(document).ready(function(){    
 
//   var annh = $('header').height();
//   $('.wrapper').css('margin-top',annh+'px');
  $('body').on('click','.close_aiod, .aiod_popup_custom_ovrly',function(e){
    e.preventDefault();
    $('.AIOD_popup, .aiod_popup_custom_ovrly').hide();    
  });
  setTimeout(function(){
    $('.AIOD_popup, .aiod_popup_custom_ovrly').show();
  }, 3000);


  
  $('body').on('change','.custom_gift-block .has_gift',function(){
  	if($(this).is(":checked")){
      	$(this).closest('.custom_gift-block').find('textarea[name="note"]').slideDown();
    }else{
    	$(this).closest('.custom_gift-block').find('textarea[name="note"]').slideUp();
    }
  });
  
  var $returnTo = $('<input type="hidden" name="return_to" value="/pages/redirect-to" />');
  var ref = document.referrer;
  if ($('#create_customer').length > 0){ //if registration form
    $returnTo.insertBefore($('#create_customer input[type="submit"]')); // add return_to input
  } else if ($('#g-recaptcha').length){
    if(ref.indexOf('account/register') > 0){
      $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
    }
  }
 
  var windowWidth = $(window).width();
   $('.category-btn').on('click', function () {
    $(this).toggleClass("active");
    $(".responsive-category").toggleClass("open");
    
      $(".collection-fliter").removeClass("open");
  });
  
   $('.filter-btn').on('click', function () {
    $(this).toggleClass("active");
    $(".collection-fliter").toggleClass("open");
      $(".responsive-category").removeClass("open");
  });
  $('.selection-name').on('click', function () {
    $(this).toggleClass("active");
    $(".select-account-nav").toggleClass("open");
  });
 
   $('.top-header .closesvg').on('click', function () {
    $(".top-header").slideUp();
     $('body').addClass('top-header-close');
  });
  /* cart popup script start here*/
  if($('body').hasClass('template-cart') == false){
    windowWidth<=540?($(".cart").on("click",function(e){e.preventDefault(),$(".cart-overlay").css({display:"block"}),$(".cart-popup").css({right:"0"}),$("body, html").toggleClass("overflow-hidden")}),$("body").on("click", '.close-cart, .cart-overlay' ,function(){$(".cart-overlay").css({display:"none"}),$(".cart-popup").css({right:"-100%"}),$("body, html").toggleClass("overflow-hidden")})):($(".cart").on("click",function(e){e.preventDefault(),$(".cart-overlay").css({display:"block"}),$("body, html").toggleClass("overflow-hidden"),$(".cart-popup").css({right:"0"})}),$("body").on("click", '.close-cart, .cart-overlay' ,function(){$(".cart-overlay").css({display:"none"}),$("body, html").toggleClass("overflow-hidden"),$(".cart-popup").css({right:"-480px"})}));
  }
  /* cart popup script end here*/
//   $(window).scroll(function(){
//     if($(this).scrollTop() > 50){
//       $("header").find('.top-header').slideUp("100");
//     }else{
//       if(!$('body').hasClass('top-header-close')){
//         $("header").find('.top-header').slideDown("100");
//       }    
//     }
//   });
//    $(window).scroll(function(){$(this).scrollTop()>200?$("header").addClass("thin-header"):$("header").removeClass("thin-header")});

  var th = $("header").find('.top-header').outerHeight();    
  var header_height = $("header").find('.middle-header').outerHeight(); 
  if($(window).scrollTop()>th){
    $("header .middle-header").addClass("sticky");
    $('.wrapper').css('margin-top',header_height+'px');
  }else{
    $("header .middle-header").removeClass("sticky");
    $('.wrapper').css('margin-top','0px');
  }
//   $(window).scrollTop()>th?$("header .middle-header").addClass("sticky"),$('.wrapper').css('margin-top','61px'):$("header .middle-header").removeClass("sticky"),$('.wrapper').css('margin-top','0px')
  $(window).scrollTop()>200?$("header").addClass("thin-header"):$("header").removeClass("thin-header")
  
  $(window).scroll(function(){
    var th = $("header").find('.top-header').outerHeight(); 
    var header_height = $("header").find('.middle-header').outerHeight(); 
    if($(window).scrollTop()>th){
      $("header .middle-header").addClass("sticky");
      $('.wrapper').css('margin-top',header_height+'px');
    }else{
      $("header .middle-header").removeClass("sticky");
      $('.wrapper').css('margin-top','0px');
    }
//     $(this).scrollTop()>th?$("header .middle-header").addClass("sticky"),$('.wrapper').css('margin-top','61px'):$("header .middle-header").removeClass("sticky"),$('.wrapper').css('margin-top','0px')
    $(this).scrollTop()>200?$("header").addClass("thin-header"):$("header").removeClass("thin-header")
  });
  $('.template-index .shopfav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode:false,
    arrows: true,
    fade: false,
    dots: false,
    touchThreshold: 100,
    infinite: true,
    responsive: [      
      {
        breakpoint: 767,
        settings: {
          arrows:false,
          adaptiveHeight: true,
          touchThreshold: 100
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows:false,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '58px',
          touchThreshold: 100,
          adaptiveHeight: true,
        }
      }
    ]

  });
  $('.related-product .shopfav').slick({
    slidesToShow: 5,
    slidesToScroll: 4,
    centerMode:false,
    arrows: true,
    fade: false,
    dots: false,
    infinite: false,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          adaptiveHeight: true,
          touchThreshold: 100
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          arrows:false,
          slidesToScroll: 1,
          adaptiveHeight: true,
          touchThreshold: 100,
          infinite: true
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows:false,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '58px',
          adaptiveHeight: false,
          touchThreshold: 100,
          infinite: true
        }
      }
    ]

  });
  $('.social-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    fade: false,
    dots: false,
    infinite: true,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          touchThreshold: 100,
          arrows:false,
          slidesToScroll: 2,
          adaptiveHeight: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          touchThreshold: 100,
          arrows:false,
          slidesToScroll: 2,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 2,
          touchThreshold: 100,
          arrows:false,
          slidesToScroll: 2,
          adaptiveHeight: true,
        }
      }
    ]

  });
  $('.shipping-wrape').slick({
    slidesToShow: 3,
    arrows:false,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    touchThreshold: 100,
    responsive: [

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          touchThreshold: 100,
          arrows:false,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      }
    ]

  });
  
  $('.models_wearing .product_flex').slick({
    slidesToShow: 3,
    arrows:true,
    slidesToScroll: 1,  
    touchThreshold: 100,    
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 2,
          touchThreshold: 100
        }
      },
      {
        breakpoint: 991,
        settings: {
          touchThreshold: 200,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          touchThreshold: 100,
          slidesToShow: 2
        }
      }
    ]

  });
  $('.hps_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode:false,
    arrows: true,
    fade: false,
    dots: false,
    touchThreshold: 100,
    infinite: true,
    responsive: [      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1
        }
      }
    ]

  });
  /*pdp slick slider  script start here*/
  if(windowWidth <= 767)
  {
  $('.product__slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,    
    dots: false,
    infinite: true,
    speed: 500,
    touchThreshold: 100,
//     asNavFor: '.product__slider-thmb',
    focusOnSelect: true,
    swipe: true,
    responsive: [

      {
        breakpoint: 767,
        settings: {
          touchThreshold: 100,
          dots: true
        },
      }
    ]

  });
       
  }

  function instslider(){
    if($('.insta_images_card').length > 0){
      $('.insta_images_card').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [          
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }else{
      setTimeout(function(){
        instslider();
      },500);
    }
  }  

  instslider();
 
//   $('.product__slider-thmb').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     infinite: true,
//     focusOnSelect: true,
//     centerMode: false,
//     vertical: true,
//     asNavFor: '.product__slider-main',
// });
  
  $('.prev_arrow').click(function(){
    $(this).closest('.shop_favorites').find('.slick-prev').trigger('click');
  });

  $('.next_arrow').click(function(){
    $(this).closest('.shop_favorites').find('.slick-next').trigger('click');
  });

  /*pdp slick slider script end here*/
  $('body').on('click','.custom_opensub , .opensub', function(e) {
    e.preventDefault();
    var _this = $(this);
    $('.sub-menu').not(_this.closest('li').find(".sub-menu")).addClass('close');
    $('.opensub').not(_this).addClass('close');
    $(this).closest('li').find(".sub-menu").toggleClass("close");
    $(this).toggleClass("close");
  });
  $('.toggle-btn').on('click', function() {
    $(".menu-ul").toggleClass("open");
    $(this).toggleClass("open");
    $('body').toggleClass("open");
  });
  /*tabs script start here*/
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })
  /*tabs script end here*/
  /*ul li make select dropdown start here*/
  if(windowWidth <= 767)
  {
    $.fn.ulSelect = function(){
      var ul = $(this);

      if (!ul.hasClass('zg-ul-select')) {
        ul.addClass('zg-ul-select');
      }
      // SVG arrow
      var arrow = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33959 0.169678C9.33959 0.169678 6.51233 2.98766 5 4.5L4.53306 4.04232L0.660409 0.169677L-2.88674e-08 0.830086L5 5.83009L10 0.830086L9.33959 0.169678Z" fill="#232323"/></svg>';
      var hash = window.location.hash;    
      if($('.tab-link[data-id="'+ hash +'"]').length > 0){
		$('li[data-id="'+hash+'"]', this).addClass('active').addClass('current').append(arrow);        
        $('.tab-content').removeClass('current');
        var id = $('li[data-id="'+hash+'"]').attr('data-tab');
        $('#'+id).addClass('current');
      }else{
        $('li:first-of-type', this).addClass('active').append(arrow);
      }      
      $(this).on('click', 'li', function(event){

        // Remove div#selected if it exists
        if ($('#selected--zg-ul-select').length) {
          $('#selected--zg-ul-select').remove();
        }
        ul.before('<div id="selected--zg-ul-select">');
        var selected = $('#selected--zg-ul-select');
        $('li #ul-arrow', ul).remove();
        ul.toggleClass('active');
        // Remove active class from any <li> that has it...
        ul.children().removeClass('active');
        // And add the class to the <li> that gets clicked
        $(this).toggleClass('active');

        var selectedText = $(this).text();
        if (ul.hasClass('active')) {
          selected.text(selectedText).addClass('active').append(arrow);
        }
        else {
          selected.text('').removeClass('active'); 
          $('li.active', ul).append(arrow);
        }
      });
      $(document).on('click', function(event){
        if($('ul.zg-ul-select').length) {
          if(!$('ul.zg-ul-select').has(event.target).length == 0) {
            return;
          }
          else {
            $('ul.zg-ul-select').removeClass('active');
            $('#selected--zg-ul-select').removeClass('active').text('');
            $('#ul-arrow').remove();
            $('ul.zg-ul-select li.active').append(arrow);
          } 
        }
      });
    }

    // Run
    $('#be-select').ulSelect();
  }

  /*ul li make select dropdown end here*/  

});
/*custome select js start here*/
function create_custom_dropdowns() {
  $('select.custome-select').each(function(i, select) {
    if (!$(this).next().hasClass('dropdown')) {
      $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
      var dropdown = $(this).next();
      var options = $(select).find('option');
      var selected = $(this).find('option:selected');
      dropdown.find('.current').html(selected.data('display-text') || selected.text());
      options.each(function(j, o) {
        var display = $(o).data('display-text') || '';
        dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
      });
    }
  });
}

// Event listeners

// Open/close
$(document).on('click', '.dropdown', function(event) {
  $('.dropdown').not($(this)).removeClass('open');
  $(this).toggleClass('open');
  if ($(this).hasClass('open')) {
    $(this).find('.option').attr('tabindex', 0);
    $(this).find('.selected').focus();
  } else {
    $(this).find('.option').removeAttr('tabindex');
    $(this).focus();
  }
});
// Close when clicking outside
$(document).on('click', function(event) {
  if ($(event.target).closest('.dropdown').length === 0) {
    $('.dropdown').removeClass('open');
    $('.dropdown .option').removeAttr('tabindex');
  }
  // event.stopPropagation();
});
// Option click
$(document).on('click', '.dropdown .option', function(event) {
  $(this).closest('.list').find('.selected').removeClass('selected');
  $(this).addClass('selected');
  var text = $(this).data('display-text') || $(this).text();
  $(this).closest('.dropdown').find('.current').text(text);
  $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
});

// Keyboard events
$(document).on('keydown', '.dropdown', function(event) {
  var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
  // Space or Enter
  if (event.keyCode == 32 || event.keyCode == 13) {
    if ($(this).hasClass('open')) {
      focused_option.trigger('click');
    } else {
      $(this).trigger('click');
    }
    return false;
    // Down
  } else if (event.keyCode == 40) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      focused_option.next().focus();
    }
    return false;
    // Up
  } else if (event.keyCode == 38) {
    if (!$(this).hasClass('open')) {
      $(this).trigger('click');
    } else {
      var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
      focused_option.prev().focus();
    }
    return false;
    // Esc
  } else if (event.keyCode == 27) {
    if ($(this).hasClass('open')) {
      $(this).trigger('click');
    }
    return false;
  }
});

$(document).ready(function() {
  
  
  //----------------------desinger js----------------------//
  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  

  // ----------------------cookie popup ----------------------- //
  $('.remove-cookies').click(function () {
    var day = $('.cookie-popup').attr('data-day');
    $(".cookie-popup").slideToggle("slow");    
    setCookie('cookipopup',true,day)
  });
  //console.log(getCookie('cookipopup'), ' = cookipopup');

  if ($(window).width() > 991) {
    if(getCookie('cookipopup')){
      $('.cookie-popup').slideUp();
    }else{
      $(".cookie-popup").slideToggle("slow");
    }
  }
  
  
  // ----------------------subscription popup ----------------------- //
  $(".removesubscribe").click(function () {    
    var day = $('.newsletter_subscribe').attr('data-day');
    $('body').removeClass('open_newsletter');
    $(".newsletter_subscribe").hide();  
    setCookie('subscribepopup',true,day);
    if ($(window).width() <= 991) {
      if(getCookie('cookipopup')){
        $('.cookie').slideUp();
      }else{
        $(".cookie").slideToggle("slow");
      }
    }
  });
  //console.log(getCookie('subscribepopup'), 'Cookie');
  if(getCookie('subscribepopup')){    
    $('.newsletter_subscribe').hide();
    $('body').removeClass('open_newsletter');
    if ($(window).width() <= 991) {
      if(getCookie('cookipopup')){

        $('.cookie').slideUp();                
      }else{
        $(".cookie").slideToggle("slow");
      }
    }
  }else{
    var location = window.location.href;
    if(location.indexOf('challenge') > 0){
      $(".newsletter_subscribe").hide();
      $('body').removeClass('open_newsletter');
    }else{
      $(".newsletter_subscribe").show();
      $('body').addClass('open_newsletter');
    }
  }

  
  
  
  $('.p-fav,.add-to-fav').on('click', function() {
    $(this).toggleClass("active");
  });		 
  $('.search-btn').on('click', function(e) {
    $(this).addClass("active");
    $(".search-btn input").focus();
    $(".right-section-header").addClass("active");
    e.stopPropagation()
  });	

  $('.m-search').on('click', function() {
    $(".m-search").addClass("active");

  });	
  create_custom_dropdowns();
  $('.filter-tag').on('click', function() {
    // event.stopPropagation();
    $(".filter").toggle();
    $(this).toggleClass("open")
  });
  $('.short-tag').on('click', function() {
    $(".sorting").toggle();
    $(this).toggleClass("open")
  });
  $(document).on("click", function(e) {
    $(".search-btn").removeClass("active");
    $(".right-section-header").removeClass("active");
  });	
  $( "<svg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.660409 5.8302C0.660409 5.8302 3.48767 3.01221 5 1.49988L5.46694 1.95755L9.33959 5.8302L10 5.16979L5 0.169793L7.87529e-09 5.16979L0.660409 5.8302Z' fill='#232323'/></svg>" ).insertAfter( ".filter .dropdown span" );

  // Add smooth scrolling to all links
  $(".rating_scroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

});
/*custome select js end here*/
/*incriment decriment spinner script start here*/
!function(n){n(".quantity-increment").click(function(){var t=n(this).siblings(".quantity"),i=parseInt(n(t).val());n(t).val(i+1)}),n(".quantity-decrement").click(function(){var t=n(this).siblings(".quantity"),i=parseInt(n(t).val());i>1&&n(t).val(i-1)})}(jQuery);
/*incriment decriment spinner script end here*/
//accordian script start here
function close_accordion_section_pdp(_this){var dh=_this.attr("data-href");jQuery(_this).removeClass("open"),jQuery(_this).closest('.accordion-container').find(dh).slideUp(400).removeClass("open")}jQuery(".js-accordion-title").click(function(e){var o=jQuery(this).attr("data-href");jQuery(e.target).is(".open")?close_accordion_section_pdp($(this)):(close_accordion_section_pdp($(this)),jQuery(this).addClass("open"),jQuery(o).slideDown(400).addClass("open")),e.preventDefault()});
//accordian script end here